"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  statisticalAnalysis: {
    common: {
      stAnalysis: '统计分析',
      materialInOutRecord: '物资出入库记录',
      spareInOutRecord: '备件出入库记录',
      pleaseEnter: '请输入',
      pleaseChoose: '请选择'
    },
    drugList: {
      drugList: '药品清单',
      vesselName: '船名',
      listDescription: '药品清单说明',
      operationManual: '操作手册',
      listSetting: '药品清单设置',
      code: '贴标编号',
      treatment: '治疗',
      drug: '药品',
      specifications: '规格',
      recommendedAmount: '推荐数量',
      currentInventory: '当前库存',
      periodOfValidity: '有效期',
      stockRemark: '库存备注',
      outStockRemark: '出库备注',
      remark: '备注',
      recommend: '推荐项',
      companyRequirements: '公司要求配',
      classOfControlledDrugs: '管制药物级别',
      extFlag: '外敷',
      controlFlag: '受控药品',
      drugNo: '药品编号',
      drugCategory: '药品类别',
      drugName: '药品名称',
      drugNameEn: '药品名称（英文）',
      specifications2: '规格型号',
      unit: '单位',
      medicineOut: '药品出库',
      registerPeriod: '登记有效期',
      outType: '出库类型',
      allOutStock: '全部出库',
      outQty: '出库数量',
      outSuccess: '出库成功',
      plsSelectData: '请勾选需要操作的数据',
      searchOnlyBeInvalid: '仅展示临过期药品',
      showVesselCertificate: '查看船舶证书'
    },
    keyWordFilter: {
      obm: '可查询物资名称、物资编号、物资供应商',
      obp: '可查询设备名称、备件名称、备件号、图纸号、备件供应商'
    },
    onBoardPartsList: {
      oBPList: '在船备件清单',
      shipName: '船舶',
      department: '部门',
      hasHarmfulSt: '包含有害物质',
      allParts: '全部',
      onParts: '在用备件',
      locationParts: '库存备件',
      deleteParts: '报废备件',
      shipNm: '船名',
      putLocation: '存放库位',
      eqpName: '设备名称',
      partsNum: '设备型号',
      status: '使用状态',
      eqpSerialNum: '设备序列号',
      partsSupplier: '备件供应商',
      partsName: '备件名称',
      partsNo: '备件号',
      drawingNo: '图纸号',
      inDrawingNo: '在图号',
      unit: '单位',
      quantity: '数量'
    },
    onBoardMaterialList: {
      mtrList: '在船物资清单',
      shipName: '船舶',
      department: '部门',
      hasHarmfulSt: '包含有害物质',
      allParts: '全部',
      onParts: '在用物资',
      locationParts: '库存物资',
      deleteParts: '报废物资',
      shipNm: '船名',
      putLocation: '存放库位',
      eqpName: '申请类别',
      partsNum: '物资类别',
      status: '使用状态',
      partsSupplier: '物资供应商',
      partsName: '物资名称',
      partsNo: '物资编号',
      drawingNo: '规格型号',
      unit: '单位',
      quantity: '数量'
    },
    applyTracking: {
      spsTracking: '备件申请跟踪',
      shipName: '船名',
      applyNo: '申请单号',
      equipmentName: '设备名称',
      currentLinks: '当前环节',
      supplierCode: '供应商编码',
      airPreparationCode: '航筹办代码',
      serviceTypes: '服务类型',
      supplier: '供应商',
      poNo: '定单号',
      orderAmount: '定单总金额',
      orderedDate: '下单日期',
      confirmDate: '下单确认日期',
      endDate: '备妥日期',
      logisticsProvider: '物流商',
      waybillNumber: '运货单号',
      shipSupplyDate: '供船日期',
      signForDate: '签收日期',
      mtrTracking: '物资申请跟踪',
      dept: '部门',
      applyType: '申请类别',
      lgReceDate: '物流日期',
      paymentCreateTime: '应付单提交日期',
      invoiceAmount: '发票合计',
      invoiceNo: '发票号',
      paymentNo: '应付单原单编码',
      financeApprovedDate: '业财审核日期',
      paymentDate: '付款日期'
    },
    sparePartsStatistical: {
      spsStatistical: '备件库存统计分析',
      locationGroup: '按库位分组',
      locationMsg: '库位信息',
      searchTime: '按时间段查询',
      startTime: '开始时间',
      endTime: '结束时间',
      company: '公司',
      shipName: '船名',
      equipmentName: '设备名称',
      equipmentNo: '设备编号',
      spsName: '备件名称',
      spsNo: '备件号',
      drawingNo: '图纸号',
      drawingItem: '在图号',
      unit: '单位',
      locationName: '库位名称',
      spsType: '备件种类',
      lastLocation: '之前库存',
      medInStocky: '期间入库',
      medConsume: '期间消耗',
      location: '库存',
      minStocky: '最低库存',
      remark: '备注',
      mtrStatistical: '物资库存统计分析',
      dept: '部门',
      custodian: '保管人',
      applyType: '申请类别',
      mtrType: '物资类别',
      mtrName: '物资名称',
      mtrNo: '物资号',
      esc: '规格型号'
    },
    budgetPerformance: {
      bPef: '预算执行情况',
      company: '公司',
      shipName: '船名',
      costType: '费项类别',
      costSub: '业务科目',
      year: '年份',
      shipComp: '船舶费用对比',
      companyComp: '公司费用对比',
      costComp: '科目费用对比',
      budget: '预算',
      actualUse: '实际使用',
      fleet: '船队',
      secondSub: '二级科目',
      thirdSub: '三级科目'
    }
  }
};